import React from 'react';
import styled from 'styled-components';

const ProductTitle = styled.div`
  text-align: left;
  h4 {
    font-weight: bold;
    font-size: 22px !important;
    text-align: left;
  }
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  text-align: left;
  font-family: 'OCRoboto';
  padding: 20px;
  flex-direction: column;
  align-items: center;
  text-align: left;

  h5 {
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
    margin: 8px;
  }
  p {
    margin: 10px;
    width: 300px;
  }
`;

export default ({ products }) => (
  <>
    {products.map((product, index) => (
      <Column key={index}>
        <img src={product.url} width="260" alt={product.title} />
        <ProductTitle>
          <h4>{product.title}</h4>
        </ProductTitle>
        <p>{product.description}</p>
      </Column>
    ))}
  </>
);
